import type { SpecificAssetId } from '../../Metamodel/SupportTypes/SpecificAssetId';
import type { PagedResult } from '../Interfaces/PagedResult';
import type { PagingParams } from '../Interfaces/PagingParams';
import { assertValidAasResponse, assignAssetParams, assignPagingParams } from '../../Utils/Restutils';
import { ClientBase } from './ClientBase';

export class DiscoveryClient extends ClientBase {
  public async lookupShells(
    assetIds?: SpecificAssetId[],
    pagingParams?: PagingParams,
    signal?: AbortSignal,
  ): Promise<PagedResult<string>> {
    const params = new URLSearchParams();
    assignAssetParams(params, assetIds);
    assignPagingParams(params, pagingParams);
    const [request, response] = await this.request(
      'get',
      '/lookup/shells',
      params,
      undefined,
      signal,
    );
    return await assertValidAasResponse(request, response);
  }

  public async lookupAssetIds(
    id: string,
    signal?: AbortSignal,
  ): Promise<SpecificAssetId[]> {
    const [request, response] = await this.request(
      'get',
      `/lookup/shells/${id}`,
      undefined,
      undefined,
      signal,
    );
    return await assertValidAasResponse(request, response);
  }

  public async createAssetLink(
    id: string,
    assetIds: SpecificAssetId[],
    signal?: AbortSignal,
  ): Promise<SpecificAssetId[]> {
    const [request, response] = await this.request(
      'post',
      `/lookup/shells/${id}`,
      undefined,
      JSON.stringify(assetIds),
      signal,
    );
    return await assertValidAasResponse(request, response);
  }

  public async deleteAssetLink(
    id: string,
    signal?: AbortSignal,
  ): Promise<void> {
    const [request, response] = await this.request(
      'delete',
      `/lookup/shells/${id}`,
      undefined,
      undefined,
      signal,
    );
    return await assertValidAasResponse(request, response, 'void');
  }
}
